import { Link } from "react-router-dom";
import type { MediaItem } from "@/mocks/movies";

interface MovieCardProps {
  item: MediaItem;
}

export default function MovieCard({ item }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:border-primary-300 hover:-translate-y-0.5 cursor-pointer"
      aria-label={`${item.title} 详情`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title} 影视海报`}
          title={`${item.title} - 蘑菇视频高清影视资源`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-semibold text-background-50">
          {item.type}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-secondary-950/80 px-2 py-0.5 text-xs font-semibold text-primary-300">
          <i className="ri-star-fill text-[11px]" aria-hidden="true"></i>
          {item.rating.toFixed(1)}
        </span>
        <div className="absolute inset-0 flex items-center justify-center bg-secondary-950/45 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 text-2xl">
            <i className="ri-play-fill" aria-hidden="true"></i>
          </span>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors" title={item.title}>
          {item.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">{item.genre} · {item.region}</p>
        <div className="mt-auto flex items-center justify-between pt-2 text-xs text-foreground-500">
          <span>{item.year}</span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-accent-500" aria-hidden="true"></i>
            热度 {item.hot}
          </span>
        </div>
      </div>
    </Link>
  );
}